import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-parentview',
  templateUrl: './parentview.component.html',
  styleUrls: ['./parentview.component.css']
})
export class ParentviewComponent implements OnInit {
  @Input() data: any;
  public pageOptions;
  public googleServices = [
    "Youtube",
    "Google calender",
    "Google maps",
    "Google docs",
    "Spread Sheet",
    "Presentation"];

  public tempArray = [];

  constructor() { }

  ngOnInit() {
    document.getElementsByClassName("globalpopup")[0]['style'].height = "auto";
    // this.appService.getPopupPageOptionsData().then(val => {
    //   this.pageOptions = val;
    // });
    this.tempArray = JSON.parse(JSON.stringify(this.data.popupProps.curComp.parentItems));
    this.tempArray = this.tempArray.reverse();
  }

  //get icon
  getIcon(tabObj) {
    if (this.pageOptions) {
      for (var i = 0; i < this.pageOptions.length; i += 1) {
        if (tabObj.title.indexOf(this.pageOptions[i].text) >= 0) {
          return this.pageOptions[i].icon;
        }
      }
    }
  }

  //get color
  getColor(tabObj) {
    if (this.pageOptions) {
      for (var i = 0; i < this.pageOptions.length; i += 1) {
        if (tabObj.title.indexOf(this.pageOptions[i].text) >= 0) {
          return this.pageOptions[i].color;
        }
      }
    }
  }

  parentItemsChange(parentPage, j) {
    this.data.popupProps.curComp.parentItemsClick(parentPage, j);
    this.data.popupProps.showPopup = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/enrichmentTabs/enrichmentTabPopups/parentview/parentview.component.ts